import React, { useCallback, useContext, useEffect, useState } from "react";
import { TMDataContext } from "../../../utils/custom_hooks/TMDataContext";
import { BasicNumericInput } from "../../common/components/generalUtilities";
import { InterviewFormContext } from "../../hooks/InterviewFormContext";
import { GoalAchievementThresholdPropsShape } from "../../interfaces/componentTypes";

export const GoalAchievementThreshold: React.FunctionComponent<GoalAchievementThresholdPropsShape> = ({
  contextOrigin,
}) => {
  const { t } = useContext(TMDataContext);
  const { goalState, setGoalState } = useContext(contextOrigin);

  let maxValue = goalState.achievementTarget ? goalState.achievementTarget : 0;
  let inputId = "goal-threshold-amount-field";

  var activeCollection =
    contextOrigin == InterviewFormContext
      ? goalState.selectedInterviewSets
      : goalState.selectedEducationLinks;

  const handleValue = useCallback(
    (input) => {
      let value =
        input.target.value == "" ? null : parseInt(input.target.value);
      if (value && value >= maxValue) {
        if (maxValue == 0) return null;
        if (maxValue == 1) return 1;
        // Threshold will equal target.  Target color will be returned before threshold color..
        else {
          value = maxValue - 1;
        }
      }
      setGoalState((prevState) => {
        return {
          ...prevState,
          achievementThreshold: value,
        };
      });
    },
    [maxValue]
  );

  useEffect(() => {
    if (goalState.achievementTarget == null) {
      setGoalState((prevState) => {
        return {
          ...prevState,
          achievementThreshold: null,
        };
      });
    } else if (goalState.achievementTarget == 1) {
      setGoalState((prevState) => {
        return {
          ...prevState,
          achievementThreshold: 1,
        };
      });
    } else {
      if (
        goalState.achievementThreshold != null &&
        goalState.achievementThreshold >= maxValue
      ) {
        if (maxValue == 0) {
          setGoalState((prevState) => {
            return {
              ...prevState,
              achievementThreshold: null,
            };
          });
        } else {
          setGoalState((prevState) => {
            return {
              ...prevState,
              achievementThreshold: maxValue - 1,
            };
          });
        }
      }
    }
  }, [goalState.achievementTarget]);

  return (
    <div className="goal-boxed-input-area">
      <div className="goal-form-input-row">
        <label htmlFor={inputId} className="goal-input-area-title">
          {t("views.goals.headings.amber_status")}
        </label>
        <div
          id="theshold-amount-prompt"
          style={{
            display: goalState.achievementTarget > 1 ? "none" : "block",
          }}
        >
          {t(`views.goals.contexts.${goalState.type.handle}.threshold_prompt`)}
        </div>
        <div
          style={{
            display: goalState.achievementTarget > 1 ? "block" : "none",
          }}
        >
          <span>
            {t(
              `views.goals.contexts.${goalState.type.handle}.amber_status_start`
            )}
          </span>{" "}
          <BasicNumericInput
            inputId={inputId}
            returnedValue={
              (goalState.achievementThreshold = null
                ? ""
                : goalState.achievementThreshold)
            }
            maxValue={maxValue}
            minValue={1}
            handleValue={handleValue}
            className="goal-input-number-field"
          />{" "}
          <span>{t("views.goals.contexts.amber_status_text_middle")}</span>{" "}
          <span className="goal-bold-highlight">{activeCollection.length}</span>{" "}
          <span>
            {t(
              `views.goals.contexts.${goalState.type.handle}.status_end_multiple`
            )}
          </span>
        </div>
      </div>
    </div>
  );
};
